import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../api-constant";
import Sidebar from "../Sidebar/sidebar";
import ResponsiveSidebar from "../Sidebar/Responsive/SideBar";
import NewNavBar from "../NavBar/Navbar";

import MyReports from "./My-Reports/My-Reports";
import axios from "axios";
import { withRouter } from "react-router";
import Navbar from "../../../_components/common/Navbar";

export class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[1].id,
      sidebarOpen: false,
      isPopOverOpenAssessmentId: false,
      isPopOverVisible: false,
      overlayIsVisible: false,
      enableNotification: false,
      showDownloadedReports: "",
      myReports: [],
      completedReports: [],
      assessmentUserId: "",
      assessmentFilteredId: "",
      collapseID: null,
      selectedYear: null,
    };
  }

  /* handle api calls */
  componentDidMount() {
    const currentYear = new Date().getFullYear();
    const id = this.props.match.params.id;
    this.setState({
      dataLoader: true,
    });

    axios
      .get(`/assessments/user/active/assessments/?year=${currentYear}`)
      .then((response) => {

        // Store participant_id in localStorage if user_assessments array is not empty
        if (response.data.user_assessments && response.data.user_assessments.length > 0) {
          const participantId = response.data.user_assessments[0].participant__id;
          localStorage.setItem('participant_id', participantId.toString());
        }





        const completedReports = response.data.user_assessments.filter(
          (filteredArrayItems) => {
            return filteredArrayItems.id == id;
          }
        );
        this.setState({
          myReports: response.data.user_assessments,
          completedReports,
          assessmentUserId: id,
          assessmentFilteredId: parseInt(id),
          dataLoader: false
        });
      })
      .catch((error) => {
        this.setState({
          dataLoader: false,
        });
      });
  }

  handleYearSelect = (year) => {




    const id = this.props.match.params.id;


    axios
      .get(`/assessments/user/active/assessments/?year=${year}`)
      .then((response) => {

        const completedReports = response.data.user_assessments.filter(
          (filteredArrayItems) => {
            return filteredArrayItems.id == id;
          }
        );
        this.setState({
          myReports: response.data.user_assessments,
          completedReports,
          assessmentUserId: id,
          assessmentFilteredId: parseInt(id),

        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleAssessmentPopOver = (assessmentId) => {
    this.setState({
      isPopOverOpenAssessmentId: assessmentId,
      overlayIsVisible: true,
    });
  };

  handleClosePopOver = () => {
    this.setState({
      isPopOverOpenAssessmentId: false,
      overlayIsVisible: false,
    });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  toggleCollapse = (collapseID) => {
    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };
  handleCloseNotification = () => {
    this.setState({
      enableNotification: false,
    });
  };
  render() {
    const userType = localStorage.getItem("usertype");


    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}



        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        ) : null}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}
        <MyReports
          collapseID={this.state.collapseID}
          toggleCollapse={this.toggleCollapse}
          isPopOverOpenAssessmentId={this.state.isPopOverOpenAssessmentId}
          handleAssessmentPopOver={this.handleAssessmentPopOver}
          handleClosePopOver={this.handleClosePopOver}
          overlayIsVisible={this.state.overlayIsVisible}
          myReports={this.state.myReports}
          completedReports={this.state.completedReports}
          assessmentUserId={this.state.assessmentUserId}
          assessmentFilteredId={this.state.assessmentFilteredId}
          handleYearSelect={this.handleYearSelect}
          isLoading={this.state.dataLoader}
        />
      </div>
    );
  }
}

export default withRouter(Reports);



// WEBPACK FOOTER //
// ./src/new/Components/Reports/index.jsx